var app = angular.module('leonardo');

var FolderFileService = function(BaseRestService, Upload, $q, ConfigThemeService, RestangularProvider,
                                 NotificationService, $http) {

  var service = new BaseRestService('document-folder-files', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('document-folder-files', false, function(file) {
      file.addRestangularMethod('dismiss', 'post', 'dismiss');
      file.addRestangularMethod('copyTo', 'post', 'copy');
      return file;
    });
  });

  service.TYPE_NORMAL = '1';
  service.TYPE_REPORT = '2';

  service.STATUS_PENDING = '0';
  service.STATUS_SOLVED = '1';
  service.STATUS_CANNOT_DO = '2';
  service.STATUS_DISMISS = '3';

  service.NOTICE_DAY_BEFORE = '1';
  service.NOTICE_WEEK_BEFORE = '2';
  service.NOTICE_MONTH_BEFORE = '3';
  service.NOTICE_MONTHS_BEFORE = '4';
  service.NOTICE_CUSTOM = '0';

  service.NOTICE_OPTIONS = [
    {id: service.NOTICE_DAY_BEFORE, name: '1 day before'},
    {id: service.NOTICE_WEEK_BEFORE, name: '1 week before'},
    {id: service.NOTICE_MONTH_BEFORE, name: '1 month before'},
    {id: service.NOTICE_MONTHS_BEFORE, name: '2 months before'},
    {id: service.NOTICE_CUSTOM, name: 'custom'}
  ];

  service.getReports = function(params) {
    return RestangularProvider.all('document-folder-files').customGET('report', params);
  };


  service.getReportsMissing = function(params){
    return RestangularProvider.all('missing-documents').customGET('report', params);
  };

  service.bulkObject = function(folder) {
    return {
      folder: folder,
      name: '',
      file: null,
      expiration: null,
      link: null,
      requirement: null
    };
  };

  service.updateFile = function(file_id, data) {
    var d = {};
    angular.forEach(data, function(value, key) {
      if (value) d[key] = value;
    });
    return Upload.upload({
      url: ConfigThemeService.generateURL('/api/2.0/document-folder-files/') + file_id + '/update-document/',
      data: {
        file: data
      }
    }).then(function() {
      // This is intentional do_something blank function
    }, function(error) {
      NotificationService.error(error);
    });
  };

  service.post = function(data) {
    var d = {};
    angular.forEach(data, function(value, key) {
      if (value) {
        d[key] = value;
      }
    });
    return Upload.upload({
      url: ConfigThemeService.generateURL('/api/2.0/document-folder-files/'),
      data: d
    }).then(function() {
      // This is intentional do_something blank function
    }, function(error) {
      NotificationService.error(error);
    });
  };

  service.put = function(id, data) {
    var defer = $q.defer();
    var d = {
      name: data.name,
      folder: data.folder,
      file: data.file
    };
    Upload.upload({
      url: ConfigThemeService.generateURL('/api/2.0/document-folder-files/') + id + '/',
      data: d,
      method: 'PUT'
    }).then(function(item) {
      delete data['name'];
      delete data['folder'];
      delete data['file'];
      if (data.length === 0) {
        defer.resolve(item);
        return;
      }
      RestangularProvider.one('document-folder-files', id).patch(data).then(function(item) {
        defer.resolve(item);
      }, function (error) {
        defer.reject(error);
      });
    }, function (error) {
      NotificationService.error(error);
      defer.reject(error);
    });
    return defer.promise;
  };

  // New authenticated method for document files
  service.getFileBlobAuthenticated = function (document, cb) {
    if (!document || !document.url_uuid) {
      console.error('getFileBlobAuthenticated requires document with url_uuid');
      cb(null);
      return;
    }
    
    var url = ConfigThemeService.generateURL('/api/2.0/document-file/') + document.url_uuid + '/';
    
    $http.get(url, { responseType: 'blob' })
      .then(function(response) {
        cb(response.data);
      })
      .catch(function(error) {
        console.error('Failed to fetch authenticated file:', error);
        cb(null);
      });
  };

  service.getFileBlob = function (url, cb) {
    // Check if this is a share URL (frontend URL) - can't fetch via XHR
    if (url.includes('/#/share/')) {
      console.error('getFileBlob called with share URL - use getFileBlobAuthenticated with document object instead');
      cb(null);
      return;
    }
    
    // Check if this is a document file URL that needs authentication
    if (url.includes('/documents/') || url.includes('/api/2.0/document-file/')) {
      console.warn('getFileBlob called with direct media URL - consider using getFileBlobAuthenticated instead');
    }
    
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.addEventListener('load', function() {
      cb(xhr.response);
    });
    xhr.addEventListener('error',function () {
      cb(xhr.response);
    });
    xhr.send();
  };

  service.blobToFile = function (blob, name) {
    blob.lastModifiedDate = new Date();
    blob.name = name;
    return blob;
  };

  // New authenticated method for document files
  service.getFileObjectAuthenticated = function (document, cb) {
    service.getFileBlobAuthenticated(document, function (blob) {
      if (blob) {
        cb(service.blobToFile(blob, document.name || 'document'));
      }
      else {
        cb(blob);
      }
    });
  };

  service.getFileObject = function(filePathOrUrl, cb) {
    var array_url = filePathOrUrl.split('/');
    service.getFileBlob(filePathOrUrl, function (blob) {
      if (blob) {
        cb(service.blobToFile(blob, array_url[array_url.length-1]));
      }
      else {
        cb(blob);
      }
    });
  };

  return service;
};

app.factory('FolderFileService', ['BaseRestService', 'Upload', '$q', 'ConfigThemeService', 'Restangular',
  'NotificationService', '$http', FolderFileService]);
